
  export default {
    props: { warning: { type: String, required: true } }
  };
